import { render, staticRenderFns } from "./TranslatableInputWidget.vue?vue&type=template&id=9c372af0&scoped=true"
import script from "./TranslatableInputWidget.vue?vue&type=script&lang=js"
export * from "./TranslatableInputWidget.vue?vue&type=script&lang=js"
import style0 from "./TranslatableInputWidget.vue?vue&type=style&index=0&id=9c372af0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c372af0",
  null
  
)

export default component.exports